import axios from 'axios';
import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
// import router from '../router/index.js';

// const date = new Date()
// let espiration = date.setTime(date.getTime() + 3600)

const store = createStore({
    state : {
        user: null,
        token : null
    },

    mutations : {
        setUser(state, user){
            state.user = user
        },
        setToken(state, token){
          state.token = token
        },
        LogOut(state){
            state.user = null
        },
    },

    actions: {
        async login({commit}, User) {
            const data = await axios.post('http://localhost:8000/api/v1/login_check', User)
            // await commit('setToken', data.data.token)
            // await commit('setUser', data.data.user)
            // axios.defaults.headers.common['Authorization'] = `Bearer ${data.data.token}`    
        },
          
    },
    getters: {
        isAuthenticated: state => !!state.user,
        administrateur : (state) => {return state.user}
    },

    plugins : [
        createPersistedState({
            storage: {
                getItem: (key) => Cookies.get(key),
                setItem: (key, value) =>
                    Cookies.set(key, value, { expires: 1, secure: false }),
                removeItem: (key) => Cookies.remove(key),
            },
        }),
    ]
})

export default store